import { Grid } from "@material-ui/core";
import React, { Component } from "react";

class OverviewVideos extends Component {
  render() {
    return (
      <Grid container justify="center" spacing={1}>
        <Grid item xs={11} container>
          <Grid xs={7}>
            <video
              style={{
                width: "calc(100% - 8px)",
                maxHeight: "calc(50vh)",
                maxWidth: "calc(100%)",
              }}
              controls
              autoPlay={false}
            >
              <source
                src="/media/Video's/video-1/video.webm"
                type="video/webm"
              />
              Your browser does not support the video tag.
            </video>
          </Grid>
          <Grid xs={5}>jhk</Grid>
          <Grid xs={12}>asdasdad</Grid>
        </Grid>
      </Grid>
    );
  }
}

export default OverviewVideos;
